import { getApiCaller, postApiCaller, putApiCaller } from "../apiCaller";

export const getAbout = async () => {
    const response = await getApiCaller("aboutUs/get-all");
    return response;
}

export const addAbout = async (payload) => {
    const response = await postApiCaller("aboutUs/create", payload);
    return response;
}

